/** Authoritative simulation rate of the game server. */
export const SERVER_TICK_HZ = 20;
export const SERVER_TICK_MS = 1000 / SERVER_TICK_HZ;

/** Fixed rate at which clients sample, predict and send movement commands. */
export const INPUT_HZ = 30;
export const INPUT_DT = 1 / INPUT_HZ;

/** Interest-management radius (metres). Entities beyond the exit radius are despawned client-side. */
export const AOI_RADIUS = 60;
export const AOI_EXIT_RADIUS = 68;

/** Collision radius of every humanoid (players, NPCs, humanoid monsters). */
export const HUMANOID_RADIUS = 0.45;

/** Render remote entities this far in the past so two snapshots are usually available to interpolate. */
export const INTERPOLATION_DELAY_MS = 110;

/** Max distance (m) between a player and an NPC / loot bag / waypoint for interactions to be accepted. */
export const INTERACT_RANGE = 4;
